module.exports = "/_next/static/images/sprite-icons-afb908bf16c57255875ef174ece8b858.svg";